import React from 'react'
import { Link } from 'react-router-dom'
import { Card } from '@myxplor/ui'
import { PlusIcon } from '@myxplor/icons'

import { RegHolderName } from '../layout'
import { toProviderRegistrations } from '../navigate'
import LocalAsyncStore from '../local-async-store'
import List from '../ui/list'
import ListItem from './views'
import Empty from './views/empty'
import ProviderCCSRegistration from './details'

const endPoint = ({ id }) => `/api/providers/${id}/provider-registrations`

const filterShape = ({ gov_id }) => ({ gov_id })

const newRegoPath = ({ id }) => toProviderRegistrations(id) + '/new'

// eslint-disable-next-line react/display-name
const empty = ({ id }) => () => <Empty newPath={newRegoPath({ id })} />

const AddLink = ({ id, records = [] }) => (
  <div className="syncButton--wrapper">
    <Link to={newRegoPath({ id })}>
      <PlusIcon left />
      Add {records.length > 0 ? 'another' : 'a'} Provider Registration
    </Link>
  </div>
)

const setupProviderRecords = ({ id, ccs_registrations }) =>
  ccs_registrations.data.map(reg => ({
    ...reg,
    provider_id: id,
  }))

export const CssRegistrations = ({ ccs_registrations, base_url, id, embedded }) => (
  <Card title={<RegHolderName />} embedded={embedded}>
    <AddLink id={id} records={ccs_registrations.data} />
    <List
      {...{
        loading: ccs_registrations.loading,
        idField: 'gov_id',
        emptyComponent: empty({ id }),
        listComponent: ListItem,
        detailComponent: ProviderCCSRegistration,
        filterOn: filterShape,
        records: setupProviderRecords({ ccs_registrations, id}),
        base_url
      }}
    />
  </Card>
)

export default LocalAsyncStore('ccs_registrations', CssRegistrations, endPoint)



// WEBPACK FOOTER //
// ./src/providers-registrations/container.js